import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import jwtInterceoptor from "../../../api/jwtInterceptor";
import { DELETE_API_URLS } from "../../../utils/constant";
import { FormErrorPopup, ConfirmPopup } from "../../parts/popups";
import Button from "../button";
import styles from "./style.module.scss";

const PropanePopupCard = (props) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const navigate = useNavigate();

  const editPropanePopupHandler = (data) => {
    navigate("/dashboard/propane-popup/edit", { state: data });
  };

  const deletePropanePopupHandler = (id) => {
    setIsDeleting(true);
    jwtInterceoptor
      .delete(DELETE_API_URLS.DELETE_PROPANE_POPUP + `${id}/`)
      .then((response) => {
        setIsDeleting(false);
        setShowConfirmDelete(false);
        console.log(response.data);
        window.location.reload();
      })
      .catch((error) => {
        setIsDeleting(false);
        setShowConfirmDelete(false);
        setError(error.message);
        console.log("Error", error);
      });
  };

  const handleDeleteClick = () => {
    setShowConfirmDelete(true);
  };

  const handleConfirmDelete = () => {
    deletePropanePopupHandler(props.id);
  };

  const handleCancelDelete = () => {
    setShowConfirmDelete(false);
  };

  return (
    <>
      <div className={styles.propanePopupCard}>
        <div className={styles.popupImage}>
          <img src={props.image} alt="Propane Popup" />
        </div>
        <div className={styles.popupContent}>
          <div className={styles.popupInfo}>
            <div className={styles.popupDetails}>
              <div className={styles.popupTitle}>
                <span className={styles.titleLabel}>Title:</span>
                <span className={styles.titleValue}>{props.title}</span>
              </div>
              <div className={styles.popupCaption}>
                <span className={styles.captionLabel}>Caption:</span>
                <span className={styles.captionValue}>{props.caption}</span>
              </div>
              {props.active !== undefined && (
                <div className={styles.activeStatus}>
                  <span className={styles.statusLabel}>Status:</span>
                  <span className={`${styles.statusValue} ${props.active ? styles.active : styles.inactive}`}>
                    {props.active ? "Active" : "Inactive"}
                  </span>
                </div>
              )}
            </div>
            <div className={styles.popupLink}>
              <span className={styles.linkLabel}>Link:</span>
              <a href={props.link} target="_blank" rel="noopener noreferrer" className={styles.linkValue}>
                {props.link}
              </a>
            </div>
          </div>
        </div>
        <div className={styles.btnContainer}>
          <Button
            label="Edit"
            secondary
            onClick={() => editPropanePopupHandler(props)}
          />
          <Button
            label="Delete"
            primary
            onClick={handleDeleteClick}
          />
        </div>
      </div>
      
      {/* Confirmation Popup */}
      <ConfirmPopup
        show={showConfirmDelete}
        title="Delete Propane Popup"
        message="Are you sure you want to delete this propane popup? This action cannot be undone."
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        loading={isDeleting}
      />
      
      {error ? (
        <FormErrorPopup
          error={error}
          close={() => setError(false)}
          errorText="Oops! An error occurred"
        />
      ) : null}
    </>
  );
};

export default PropanePopupCard;
